import { render, staticRenderFns } from "./RushPlayer.vue?vue&type=template&id=2fe20dcc&scoped=true&"
import script from "./RushPlayer.vue?vue&type=script&lang=js&"
export * from "./RushPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RushPlayer.vue?vue&type=style&index=0&id=2fe20dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe20dcc",
  null
  
)

export default component.exports